import { createAction, props } from '@ngrx/store'
import { Article } from './article.model'
import { ListingState } from './article.reducer'
import { NamedSearchParameters } from '../shared/components/filtering-search-component-base/filtering-search-types'
import { Dictionary } from '@ngrx/entity'

export const loadArticles = createAction(
  '[Articles] Load',
  props<{ articles: Article[], listing: ListingState, search: NamedSearchParameters, area: string, extraData: Dictionary<any> }>()
)

export const loadAnArticle = createAction(
  '[Articles] Load An Article',
  props<{ article: Article, listing: ListingState, search: NamedSearchParameters, area: string, extraData: Dictionary<any> }>()
)

export const loadArticlesRemote = createAction(
  '[Articles] Get Articles',
  props<{ action: any }>()
)
export const loadArticlesFromNewsletterRemote = createAction(
  '[Articles] Get Articles From Newsletter',
  props<{ action: any }>()
)

export const loadAnArticleRemote = createAction(
  '[Articles] Get An Article',
  props<{ action: any }>()
)

export const articlesLoaded = createAction(
  '[Articles] Articles Loaded',
)

export const articleLoaded = createAction(
  '[Articles] Article Loaded',
)

export const setCurrentArticle = createAction(
  '[Articles] Set Current Article',
  props<{ id: number }>()
)

export const removeAllArticles = createAction(
  '[Articles] Remove All',
)

export const resetArticleState = createAction(
  '[Articles] Reset',
)

export const updateSearchParameters = createAction(
  '[Articles] Update Search',
  props<{ parameters: Dictionary<any>, area: string, order: any}>()
)

export const setSearchParameters = createAction(
  '[Articles] Set Search',
  props<{ parameters: Dictionary<any>, area: string, order: any}>()
)

export const downloadArticlesRemote = createAction(
  '[Articles] Download',
  props<{ action: any }>()
)

export const downloadInProgress = createAction(
  '[Articles] Download in progress',
  props<{ downloadID: string }>()
)

export const downloadFinished = createAction(
  '[Articles] Download finished',
)


export const articlesLoadedError = createAction(
  '[Articles API] Articles Loaded Error'
)